import { logOut } from './utils';
import { Navigate } from 'react-router-dom';

const Logout = () => {

    const logout = () => {
        if (logOut()) {
            alert("Logged out.")
        } else {
            alert("Oops, something went wrong, maybe you are not logged in.");
        }
        return <Navigate replace to="/login" />
    }

    return logout()

}

export default Logout
